export const convertTimeoutToString = (timeoutMs: number) => {
  const totalTimeoutInSeconds = timeoutMs / 1000;
  const timeoutMinutes = Math.floor(totalTimeoutInSeconds / 60);
  const timeoutSeconds = totalTimeoutInSeconds % 60;
  return `${
    timeoutMinutes > 0 ? `${timeoutMinutes} min, ` : ''
  }${timeoutSeconds} sec`;
};
